import api from '../config/axios';
import { ProcessingResult, CreateInvoiceResult, InvoiceAIData } from '../types/aiInvoice';

class AIInvoiceService {
  /**
   * Process invoice PDF with AI
   * @param file PDF file to process
   * @returns Processing result with extracted data
   */
  async processInvoiceWithAI(file: File): Promise<ProcessingResult> {
    try {
      const formData = new FormData();
      formData.append('pdf', file);

      const response = await api.post('/invoices-ai/process-pdf', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 120000, // 2 minutes timeout for AI processing
      });

      return response.data;
    } catch (error: any) {
      console.error('AI Processing Error:', error);
      throw new Error(
        error.response?.data?.error || 
        error.response?.data?.details ||
        'Failed to process invoice with AI'
      );
    }
  }

  /**
   * Create invoice from AI-extracted data
   * @param invoiceData Validated invoice data from AI
   * @param pdfFile Original PDF file
   * @returns Created invoice
   */
  async createInvoiceFromAI(
    invoiceData: InvoiceAIData,
    pdfFile: File
  ): Promise<CreateInvoiceResult> {
    try {
      const formData = new FormData();
      formData.append('pdf', pdfFile);
      formData.append('invoiceData', JSON.stringify(invoiceData));

      const response = await api.post('/invoices-ai/create-with-pdf', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 60000, // 1 minute timeout
      });

      return response.data;
    } catch (error: any) {
      console.error('Create Invoice Error:', error);
      throw new Error(
        error.response?.data?.error ||
        error.response?.data?.details ||
        'Failed to create invoice'
      );
    }
  }
}

export default new AIInvoiceService();

